// ═══ 대행사(broker) 회사 화면 행 라벨 — 순수 함수 (GUIDE-client §1.3 · 앱 broker_row_labels.dart 와 같은 정의) ═══
// 행 = GET /cancel-requests 행 또는 상세 request (unitName·accountName·accountKind·requesterIsBroker·requestedByMe).
// 구 서버(키 없음): accountKind '' → 거래처 라벨 없음 · requestedByMe undefined → 내 신청으로 본다(=== false 로만 판정).
import { withKoJosa } from './koJosa';

/// 효과 단위가 계정 본인 몫인지 — unitName 이 계정명과 같다.
export function isSelfName(row) {
  var r = row || {};
  return !!r.unitName && r.unitName === r.accountName;
}

/// 대행사 화면 행 거래처 라벨. 대행사가 보는 행은 requestedByMe 와 requesterIsBroker 가 같고,
/// 하위 회사가 보는 행은 다르다 → 하위 회사 화면에는 라벨이 없다. 본인 몫은 '{name} (본인)'.
export function unitLabel(row, t) {
  var r = row || {};
  var mine = r.requestedByMe !== false;
  if (r.accountKind !== 'broker' || !r.unitName || mine !== !!r.requesterIsBroker) return '';
  return isSelfName(r) ? t('malsoModeBrokerSelfName', { name: r.unitName }) : r.unitName;
}

/// '○○가 신청' — 다른 회사가 넣은 신청일 때만. 조사는 ko 에서만 이름에 붙인다.
export function requestedBy(row, t, locale) {
  var r = row || {};
  if (r.requestedByMe !== false || !r.requesterCompanyName) return '';
  return t('malsoModeRequestedBy', { name: withKoJosa(locale, r.requesterCompanyName, '이', '가') });
}
